// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-area {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.header-area {\n  width: 110px;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  color: #0072c6 !important;\n  font-weight: 600;\n}\n.value-area {\n  -ms-flex-negative: 1;\n      flex-shrink: 1;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}", ""]);
// Exports
module.exports = exports;
